const formatAreaLabel = ({ name, gorkoId }) => {
	const suffix = gorkoId ? ` #${gorkoId}` : '';

	return `${name}${suffix}`;
};

export const pluralizeAreas = (count) => {
	const n = Math.abs(count) % 100;
	const n1 = n % 10;

	if (n > 10 && n < 20) return `${count} площадок`;
	if (n1 > 1 && n1 < 5) return `${count} площадки`;
	if (n1 === 1) return `${count} площадка`;

	return `${count} площадок`;
};

export const getCompanyAreaLabel = (companyById, id) => {
	const company = companyById?.[String(id)];

	if (!company) return String(id);

	if (typeof company === 'string') return company;

	return formatAreaLabel(company);
};

export const createCompanyByIdMap = (companies = []) =>
	Object.fromEntries(
		companies.map((company) => [String(company.id), company]),
	);

export const mapCompanyToAreaOption = (company) => ({
	label: formatAreaLabel(company),
	value: String(company.id),
});

const hasActiveGroupMembership = (company) =>
	(company.groupLinksAsMember ?? []).some((link) => !link.unlinked);

export const mapCompaniesToAreaOptions = (
	companies,
	{ excludeIds = [] } = {},
) => {
	const excluded = new Set(excludeIds.map(String));

	return companies
		.filter((company) => {
			if (excluded.has(String(company.id))) return false;
			if (company.isGroup) return false;
			if (hasActiveGroupMembership(company)) return false;

			return true;
		})
		.map(mapCompanyToAreaOption);
};

export const collectLinkedCompanies = (company) => {
	const linked = [];
	const seen = new Set();

	const addCompany = (item) => {
		if (!item?.id || seen.has(item.id)) return;

		seen.add(item.id);
		linked.push(item);
	};

	if (company.isGroup) {
		for (const link of company.groupLinksAsGroup || []) {
			if (!link.unlinked) {
				addCompany(link.company);
			}
		}

		return linked;
	}

	for (const memberLink of company.groupLinksAsMember || []) {
		if (memberLink.unlinked) continue;

		for (const groupLink of memberLink.group?.groupLinksAsGroup || []) {
			if (groupLink.unlinked) continue;

			const linkedCompany = groupLink.company;

			if (linkedCompany?.id && linkedCompany.id !== company.id) {
				addCompany(linkedCompany);
			}
		}
	}

	return linked;
};

export const mapLinkedAreaOptions = (company) => {
	return collectLinkedCompanies(company).map(mapCompanyToAreaOption);
};
